const ActionTypes = {
  SET_ROCKECTS: 'SET_ROCKECTS',
  RESERVED_ROCKET: 'RESERVED_ROCKECTS',
  CANCEL_RESERVED_ROCKECT: 'CANCEL_RESERVED_ROCKECT',
};

// export const rocketBookingHandler = 'bookingRocketHandler';

export default ActionTypes;
